import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PropTypes from "prop-types";
import { useTranslation, withTranslation } from "react-i18next";

// Livreur Redux States
import {
  GET_LIVREURS,
  ADD_NEW_LIVREUR,
  UPDATE_LIVREUR,
} from "./actionType";

import {
  livreurApiResponseSuccess,
  livreurApiResponseError,

  addLivreurFail,
  addLivreurSuccess,
  updateLivreurSuccess,
  updateLivreurFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getLivreurs as getLivreursApi,
  addNewLivreur,
  updateLivreur,
} from "../../helpers/fakebackend_helper";

function* getLivreurs() {
  try {
    const response = yield call(getLivreursApi);
    yield put(livreurApiResponseSuccess(GET_LIVREURS, response));
  } catch (error) {
    yield put(livreurApiResponseError(GET_LIVREURS, error));
  }
}

function* onUpdateLivreur({ payload: livreur}) {
  console.log(livreur);
  try {
    const response = yield call(updateLivreur, livreur);
    console.log(response);
    yield put(updateLivreurSuccess(response));
  } catch (error) {
    console.log(error);
    yield put(updateLivreurFail(error));
  }
}


function* onAddNewLivreur({ payload: livreur }) {
  try {
    console.log(livreur);
    const response = yield call(addNewLivreur, livreur);
    yield put(addLivreurSuccess(response));
  } catch (error) {
    yield put(addLivreurFail(error));
  }
}

export function* watchGetLivreurs() {
  yield takeEvery(GET_LIVREURS, getLivreurs);
}


export function* watchUpdateLivreur() {
  yield takeEvery(UPDATE_LIVREUR, onUpdateLivreur);
}

export function* watchAddNewLivreur() {
  yield takeEvery(ADD_NEW_LIVREUR, onAddNewLivreur);
}

function* livreurSaga() {
  yield all([
    fork(watchGetLivreurs),
    fork(watchUpdateLivreur),
    fork(watchAddNewLivreur),
  ]);
}

export default livreurSaga;
